import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function PaymentMethod({setPaymentMethodProps}) {
  const [method, setPaymentMethod] = React.useState('');

  const handleChange = (event) => {
    setPaymentMethod(event.target.value);
    setPaymentMethodProps(event.target.value)
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Payment Method</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select2"
          value={method}
          label="Payment Method"
          onChange={handleChange}
        >
          <MenuItem value={"bank tansfer"}>Bank Transfer</MenuItem>
          <MenuItem value={"credi card"}>Credit Card</MenuItem>
          <MenuItem value={"mobile money"}>Mobile Money </MenuItem>
          <MenuItem value={"paypal"}>Paypal </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}